// Constants to prevent recreation - ES2022+ Object.freeze for immutability
const SIZE_CLASSES = Object.freeze({
  sm: 'spinner-border-sm',
  md: '',
  lg: 'spinner-border-lg',
})

/**
 * Loading Spinner component for async operations
 * Optimized for React 19+ with constants and minimal re-renders
 * @param {Object} props - Component props
 * @param {string} [props.message='Loading...'] - Loading message to display
 * @param {'sm'|'md'|'lg'} [props.size='md'] - Spinner size variant
 * @returns {JSX.Element} Loading spinner component
 */
function LoadingSpinner({ message = 'Loading...', size = 'md' }) {
  const sizeClass = SIZE_CLASSES[size] ?? SIZE_CLASSES.md
  
  return (
    <div className="loading-spinner-enhanced">
      <div className={`spinner-border text-primary ${sizeClass}`} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      {message && (
        <div className="loading-text-enhanced">{message}</div>
      )}
    </div>
  )
}

export default LoadingSpinner
